import { render, staticRenderFns } from "./userSelectBossDialog.vue?vue&type=template&id=197cceea&scoped=true"
import script from "./userSelectBossDialog.vue?vue&type=script&lang=js"
export * from "./userSelectBossDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197cceea",
  null
  
)

export default component.exports